import * as React from "react";
import Typography from "@mui/material/Typography";
import { Box, IconButton, Paper } from "@mui/material";
import SwitchAccessShortcutIcon from "@mui/icons-material/SwitchAccessShortcut";
import RepeatOnIcon from "@mui/icons-material/RepeatOn";
import Slider from "@mui/material/Slider";

export default function ShortCutEnable({
  handleUseShortcuts,
  useShortcuts,
  unlimitedRepeat,
  handleSubtitleSideBar,
  subtitleSideBar,
}) {
  const [opacity, setOpacity] = React.useState(0.05);
  const [showAlert, setShowAlert] = React.useState(false);

  const handleChange = (event, newValue) => {
    if (typeof newValue === "number") {
      handleSubtitleSideBar({ size: newValue });
    }
  };

  return (
    <Paper
      onMouseEnter={() => {
        setOpacity(1);
      }}
      onMouseLeave={() => {
        setOpacity(0.05);
      }}
      style={{
        display: "flex",
        position: "absolute",
        top: "0px",
        left: "15px",
        opacity: unlimitedRepeat ? 1 : opacity,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {subtitleSideBar.active ? (
        <Box sx={{ width: "120px", mx: 1 }}>
          <Typography sx={{ fontSize: "8px" }}>
            Subtitles sidebar size
          </Typography>
          <Slider
            sx={{ direction: "rtl" }}
            aria-label="Temperature"
            value={subtitleSideBar["size"]}
            valueLabelDisplay="auto"
            min={15}
            step={1}
            max={100}
            color="secondary"
            onChange={handleChange}
          />
        </Box>
      ) : null}

      {unlimitedRepeat ? <RepeatOnIcon /> : null}
      {showAlert ? (
        <Typography
          sx={{ fontSize: "10px", color: useShortcuts.on ? "green" : "red" }}
        >
          کلیدهای میانبر {useShortcuts.on ? "فعال" : "غیر فعال"} شد
        </Typography>
      ) : null}
      <IconButton
        color={useShortcuts.on ? "success" : "error"}
        onClick={() => {
          handleUseShortcuts({ on: !useShortcuts.on });
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
        }}
      >
        <Typography>{useShortcuts.on ? "On" : "Off"}</Typography>
        <SwitchAccessShortcutIcon />
      </IconButton>
    </Paper>
  );
}
